import React, { useEffect, useState } from 'react';
import reportSettingStyles from '../ReportSettings.style';
import {
	FormControl,
	FormControlLabel,
	RadioGroup,
	Radio,
	useMediaQuery,
	Box
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import RbTextField from '../text-field/TextField.component';
import { useSelector } from 'react-redux';
import moment from 'moment';

const EndReport = (props) => {
	const isSmallScreen = useMediaQuery('(max-width:600px)');
	const marginStyle = '16px 16px 0px 0px';
	// eslint-disable-next-line prettier/prettier
	const {
		endReportType,
		setReportType,
		occurance,
		setOccurance,
		setEndDate,
		endDate,
		showError,
		error
	} = props;
	const classes = reportSettingStyles();
	const [date, setDate] = useState(new Date());

	const isEditEnabled = useSelector((state) => state.dashboardReducer.isEditEnabled);

	const hanldeChange = (val) => {
		if (endReportType === 'After') {
			setOccurance(val);
			if (['', '0', undefined, null].includes(val)) {
				showError({
					...error,
					eDate: true
				});
			}
			return;
		}
		if (endReportType === 'By') {
			setDate(val);
			setEndDate(val);
			if (endReportType === 'By' && moment(val).isSame(moment().startOf('day'), 'd')) {
				showError({
					...error,
					eDate: true
				});
			} else {
				showError({
					...error,
					eDate: false
				});
			}
		}
	};

	const handleRadioChange = (event) => {
		const val = event.target.value;
		setReportType(val);
		setDate(endDate);
		setOccurance(occurance);
		showError({
			...error,
			eDate: false
		});
	};

	useEffect(() => {
		if (isEditEnabled) {
			setDate(endDate);
		}
	}, [isEditEnabled]);

	const valBy = (val) => {
		return (
			<Box className={classes.radioLabelBox}>
				<span style={{ margin: marginStyle }}>{val}</span>
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<KeyboardDatePicker
						aria-label="End Date picker"
						className={classes.dateTimeField}
						KeyboardButtonProps={{ 'aria-label': 'End Date Picker' }}
						disableToolbar
						disabled={endReportType === 'After'}
						inputVariant="outlined"
						variant="inline"
						format="MM/dd/yyyy"
						id="end-date-picker"
						value={date}
						disablePast={true}
						onChange={hanldeChange}
						helperText={null}
						InputProps={{
							style: {
								fontSize: isSmallScreen ? 14 : 16,
								fontFamily: 'Bogle-Regular',
								marginRight: '8px'
							},
							readOnly: true
						}}
					/>
				</MuiPickersUtilsProvider>
			</Box>
		);
	};

	const getOccurance = (val) => {
		return (
			<Box className={classes.radioLabelBox}>
				<span style={{ margin: marginStyle }}>{val}</span>
				<RbTextField
					type="number"
					id="occurance"
					label="1~9999"
					disabled={endReportType === 'By'}
					style={{ width: '85px', marginRight: '16px' }}
					value={occurance}
					defaultValue=""
					onChange={(e) => hanldeChange(e.target.value)}
					onInput={(e) => {
						e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4);
					}}
				/>
				<span style={{ margin: marginStyle }}>occurrence</span>
			</Box>
		);
	};

	const getLabel = (val) => {
		if (val === 'By') {
			return valBy(val);
		}

		return getOccurance(val);
	};

	return (
		<FormControl variant="standard">
			<RadioGroup
				aria-labelledby="end-report-radios"
				value={endReportType}
				onChange={handleRadioChange}>
				<FormControlLabel value="By" control={<Radio color="primary" />} label={getLabel('By')} />
				<FormControlLabel
					style={{ marginTop: '16px' }}
					value="After"
					control={<Radio color="primary" />}
					label={getLabel('After')}
				/>
			</RadioGroup>
		</FormControl>
	);
};

export default EndReport;
